export default __webpack_public_path__ + "static/media/img_12.1e6bc765.webp";